class Configuration {
	// eslint-disable-next-line sonarjs/cognitive-complexity
	static value(variableName) {
		let result = null
		let environmentVariableValue = Configuration.environmentVariables[variableName]
		if (environmentVariableValue && environmentVariableValue.startsWith('%')) {
			const environmentVariableName = environmentVariableValue.replace(/%/g, '')
			environmentVariableValue = process.env[environmentVariableName]
		}
		if (environmentVariableValue && !environmentVariableValue.startsWith('%')) {
			result = environmentVariableValue
		}
		if (result && result.startsWith('{') && result.endsWith('}')) {
			result = JSON.parse(result)
		} else if (result && !isNaN(result) && !isNaN(parseFloat(result))) {
			result = parseFloat(result)
		} else if (result && !isNaN(result) && isNaN(parseFloat(result))) {
			result = parseInt(result)
		} else if (result && ['true'].includes(result.trim().toLowerCase())) {
			result = true
		} else if (result && ['false'].includes(result.trim().toLowerCase())) {
			result = false
		} else if (result && [''].includes(result.trim().toLowerCase())) {
			result = ''
		} else if (result && ['null'].includes(result.trim().toLowerCase())) {
			result = null
		} else if (result && ['undefined'].includes(result.trim().toLowerCase())) {
			result = undefined
		}

		return result
	}

	static get environmentVariables() {
		return {
			VUE_APP_MODE: 'hotfix',
			VUE_APP_ENV_NAME: 'HOTFIX',
			VUE_APP_SOURCE_MAP: 'true',
			VUE_APP_SENTRY_ENABLE: 'true',
			VUE_APP_SENTRY_BROWSER_PROFILING_ENABLE: 'false',
			VUE_APP_SENTRY_BROWSER_TRACING_ENABLE: 'false',
			VUE_APP_SENTRY_FEEDBACK_ENABLE: 'false',
			VUE_APP_SENTRY_INP_SAMPLE_RATE: '0',
			VUE_APP_SENTRY_CAPTURE_CONSOLE_ENABLE: 'true',
			VUE_APP_SENTRY_EXTRA_ERROR_DATA_ENABLE: 'true',
			VUE_APP_SENTRY_REPORTING_OBSERVER_ENABLE: 'true',
			VUE_APP_SENTRY_REPLAY_ENABLE: 'false',
			VUE_APP_SENTRY_REPLAY_CANVAS_ENABLE: 'false',
			VUE_APP_SENTRY_DSN: 'https://72d488754bfb29fef9fe2f2dfb8a35f5@sentry.infra.welyb.fr/3',
			VUE_APP_SENTRY_DEBUG_ENABLE: 'false',
			VUE_APP_SENTRY_SAMPLE_RATE: '1',
			VUE_APP_SENTRY_IGNORE_ERRORS: '^[Vuetify] Image load failed.*',
			VUE_APP_SENTRY_ATTACH_PROPS_ENABLE: 'true',
			VUE_APP_SENTRY_TRACE_SAMPLE_RATE: '0',
			VUE_APP_SENTRY_HOOKS: 'activate,create,destroy,mount,unmount,update',
			VUE_APP_SENTRY_LOG_ERRORS: 'true',
			VUE_APP_SENTRY_REPLAY_SESSION_SAMPLE_RATE: '0',
			VUE_APP_SENTRY_REPLAY_ERROR_SAMPLE_RATE: '0',
			VUE_APP_SENTRY_PROFILE_SESSION_SAMPLE_RATE: '0',
			VUE_APP_SENTRY_PROFILE_SAMPLE_RATE: '0',
			VUE_APP_ROOT_API: 'https://api.hotfix.welyb.fr',
			VUE_APP_ROOT_WEBDAV: 'https://dav.hotfix.welyb.fr',
			VUE_APP_ROOT_WOPI: 'https://wopi.hotfix.welyb.fr',
			VUE_APP_MAX_COMPANY_NUMBER: '1000000000',
			VUE_APP_UPLOAD_CHUNK_SIZE: '10485760',
			VUE_APP_UPLOAD_MAX_CONCURRENT_CHUNKS: '5',
			VUE_APP_UPLOAD_RETRY_INTERVAL: '30',
			VUE_APP_UPLOAD_ENABLE_CANCEL: 'true',
			VUE_APP_HUBSPOT_ACTIVE_CHATFLOW_ID: '{"fr":"webapp3","pt":"webappPT"}',
			VUE_APP_DOCUSIGN_CLIENT_ID: '0f949dfe-d5a7-43e3-822c-9322c7133bb6',
			VUE_APP_DOCUSIGN_CALLBACK: '/api/oauth/redirect/docusign',
			VUE_APP_JITSI_MEET_SCRIPT_URL: 'https://jitsi-meet.dev.welyb.fr/external_api.js',
			VUE_APP_JITSI_MEET_SERVER: 'jitsi-meet.dev.welyb.fr',
			VUE_APP_ECM_AUTOREFRESH_INTERVAL: '60000',
			VUE_APP_ECM_TREE_STRUCTURE_CREATION_AUTOREFRESH: 'true',
			VUE_APP_ECM_TREE_STRUCTURE_CREATION_AUTOREFRESH_FREQUENCY: '2000',
			VUE_APP_ECM_TREE_STRUCTURE_CREATION_SHOW_PROGRESS: 'true',
			VUE_APP_MATOMO_ENABLED: 'false',
			VUE_APP_MATOMO_URL: 'https://matomo.infra.welyb.fr',
			VUE_APP_MATOMO_SITE_ID: '1',
			VUE_APP_MATOMO_TRACKER_FILENAME: 'matomo',
			VUE_APP_MATOMO_TRACKER_URL: 'https://tracker.matomo.infra.welyb.fr/matomo.php',
			VUE_APP_MATOMO_TRACKER_SCRIPT_URL: 'https://tracker.matomo.infra.welyb.fr/matomo.js',
			VUE_APP_MATOMO_ENABLE_LINK_TRACKING: 'true',
			VUE_APP_MATOMO_REQUIRE_CONSENT: 'false',
			VUE_APP_MATOMO_TRACK_INITIAL_VIEW: 'true',
			VUE_APP_MATOMO_COOKIES_DISABLE: 'false',
			VUE_APP_MATOMO_HEARTBEAT_TIMER_ENABLE: 'true',
			VUE_APP_MATOMO_HEARTBEAT_TIMER_INTERVAL: '15',
			VUE_APP_MATOMO_DEBUG: 'false',
			VUE_APP_BASE_DOMAIN: 'hotfix.welyb.fr',
			VUE_APP_MOBILEAPP_GITLAB_PROJECT: 'welyb/test-formulaire-app-mobile',
			VUE_APP_KEYCLOAK_URL: 'https://keycloak.dev.welyb.fr',
			VUE_APP_KEYCLOAK_REALM: 'welyb-hotfix',
			VUE_APP_KEYCLOAK_CLIENT_ID: 'welyb-hotfix-frontend'
		}
	}

	static get VUE_APP_MODE() {
		return Configuration.value('VUE_APP_MODE')
	}
	static get VUE_APP_ENV_NAME() {
		return Configuration.value('VUE_APP_ENV_NAME')
	}
	static get VUE_APP_SOURCE_MAP() {
		return Configuration.value('VUE_APP_SOURCE_MAP')
	}
	static get VUE_APP_SENTRY_ENABLE() {
		return Configuration.value('VUE_APP_SENTRY_ENABLE')
	}
	static get VUE_APP_SENTRY_BROWSER_PROFILING_ENABLE() {
		return Configuration.value('VUE_APP_SENTRY_BROWSER_PROFILING_ENABLE')
	}
	static get VUE_APP_SENTRY_BROWSER_TRACING_ENABLE() {
		return Configuration.value('VUE_APP_SENTRY_BROWSER_TRACING_ENABLE')
	}
	static get VUE_APP_SENTRY_FEEDBACK_ENABLE() {
		return Configuration.value('VUE_APP_SENTRY_FEEDBACK_ENABLE')
	}
	static get VUE_APP_SENTRY_INP_SAMPLE_RATE() {
		return Configuration.value('VUE_APP_SENTRY_INP_SAMPLE_RATE')
	}
	static get VUE_APP_SENTRY_CAPTURE_CONSOLE_ENABLE() {
		return Configuration.value('VUE_APP_SENTRY_CAPTURE_CONSOLE_ENABLE')
	}
	static get VUE_APP_SENTRY_EXTRA_ERROR_DATA_ENABLE() {
		return Configuration.value('VUE_APP_SENTRY_EXTRA_ERROR_DATA_ENABLE')
	}
	static get VUE_APP_SENTRY_REPORTING_OBSERVER_ENABLE() {
		return Configuration.value('VUE_APP_SENTRY_REPORTING_OBSERVER_ENABLE')
	}
	static get VUE_APP_SENTRY_REPLAY_ENABLE() {
		return Configuration.value('VUE_APP_SENTRY_REPLAY_ENABLE')
	}
	static get VUE_APP_SENTRY_REPLAY_CANVAS_ENABLE() {
		return Configuration.value('VUE_APP_SENTRY_REPLAY_CANVAS_ENABLE')
	}
	static get VUE_APP_SENTRY_DSN() {
		return Configuration.value('VUE_APP_SENTRY_DSN')
	}
	static get VUE_APP_SENTRY_DEBUG_ENABLE() {
		return Configuration.value('VUE_APP_SENTRY_DEBUG_ENABLE')
	}
	static get VUE_APP_SENTRY_SAMPLE_RATE() {
		return Configuration.value('VUE_APP_SENTRY_SAMPLE_RATE')
	}
	static get VUE_APP_SENTRY_IGNORE_ERRORS() {
		const ignoreErrors = Configuration.value('VUE_APP_SENTRY_IGNORE_ERRORS') ? Configuration.value('VUE_APP_SENTRY_IGNORE_ERRORS').split(',') : []
		return ignoreErrors.map(message => {
			message = message.replaceAll('[', '\\[').replaceAll(']', '\\]')
			// Motifs issus de la configuration de déploiement (VUE_APP_SENTRY_IGNORE_ERRORS), jamais d'une saisie utilisateur
			return new RegExp(message) // nosemgrep
		})
	}
	static get VUE_APP_SENTRY_ATTACH_PROPS_ENABLE() {
		return Configuration.value('VUE_APP_SENTRY_ATTACH_PROPS_ENABLE')
	}
	static get VUE_APP_SENTRY_TRACE_SAMPLE_RATE() {
		return Configuration.value('VUE_APP_SENTRY_TRACE_SAMPLE_RATE')
	}
	static get VUE_APP_SENTRY_HOOKS() {
		return Configuration.value('VUE_APP_SENTRY_HOOKS')
	}
	static get VUE_APP_SENTRY_LOG_ERRORS() {
		return Configuration.value('VUE_APP_SENTRY_LOG_ERRORS')
	}
	static get VUE_APP_SENTRY_REPLAY_SESSION_SAMPLE_RATE() {
		return Configuration.value('VUE_APP_SENTRY_REPLAY_SESSION_SAMPLE_RATE')
	}
	static get VUE_APP_SENTRY_REPLAY_ERROR_SAMPLE_RATE() {
		return Configuration.value('VUE_APP_SENTRY_REPLAY_ERROR_SAMPLE_RATE')
	}
	static get VUE_APP_SENTRY_PROFILE_SESSION_SAMPLE_RATE() {
		return Configuration.value('VUE_APP_SENTRY_PROFILE_SESSION_SAMPLE_RATE')
	}
	static get VUE_APP_SENTRY_PROFILE_SAMPLE_RATE() {
		return Configuration.value('VUE_APP_SENTRY_PROFILE_SAMPLE_RATE')
	}
	static get VUE_APP_ROOT_API() {
		return Configuration.value('VUE_APP_ROOT_API')
	}
	static get VUE_APP_ROOT_WEBDAV() {
		return Configuration.value('VUE_APP_ROOT_WEBDAV')
	}
	static get VUE_APP_ROOT_WOPI() {
		return Configuration.value('VUE_APP_ROOT_WOPI')
	}
	static get VUE_APP_MAX_COMPANY_NUMBER() {
		return Configuration.value('VUE_APP_MAX_COMPANY_NUMBER')
	}
	static get VUE_APP_UPLOAD_CHUNK_SIZE() {
		return Configuration.value('VUE_APP_UPLOAD_CHUNK_SIZE')
	}
	static get VUE_APP_UPLOAD_MAX_CONCURRENT_CHUNKS() {
		return Configuration.value('VUE_APP_UPLOAD_MAX_CONCURRENT_CHUNKS')
	}
	static get VUE_APP_UPLOAD_RETRY_INTERVAL() {
		return Configuration.value('VUE_APP_UPLOAD_RETRY_INTERVAL')
	}
	static get VUE_APP_UPLOAD_ENABLE_CANCEL() {
		return Configuration.value('VUE_APP_UPLOAD_ENABLE_CANCEL')
	}
	static get VUE_APP_HUBSPOT_ACTIVE_CHATFLOW_ID() {
		return Configuration.value('VUE_APP_HUBSPOT_ACTIVE_CHATFLOW_ID')
	}
	static get VUE_APP_DOCUSIGN_CLIENT_ID() {
		return Configuration.value('VUE_APP_DOCUSIGN_CLIENT_ID')
	}
	static get VUE_APP_DOCUSIGN_CALLBACK() {
		return Configuration.value('VUE_APP_DOCUSIGN_CALLBACK')
	}
	static get VUE_APP_JITSI_MEET_SCRIPT_URL() {
		return Configuration.value('VUE_APP_JITSI_MEET_SCRIPT_URL')
	}
	static get VUE_APP_JITSI_MEET_SERVER() {
		return Configuration.value('VUE_APP_JITSI_MEET_SERVER')
	}
	static get VUE_APP_ECM_AUTOREFRESH_INTERVAL() {
		return Configuration.value('VUE_APP_ECM_AUTOREFRESH_INTERVAL')
	}
	static get VUE_APP_ECM_TREE_STRUCTURE_CREATION_AUTOREFRESH() {
		return Configuration.value('VUE_APP_ECM_TREE_STRUCTURE_CREATION_AUTOREFRESH')
	}
	static get VUE_APP_ECM_TREE_STRUCTURE_CREATION_AUTOREFRESH_FREQUENCY() {
		return Configuration.value('VUE_APP_ECM_TREE_STRUCTURE_CREATION_AUTOREFRESH_FREQUENCY')
	}
	static get VUE_APP_ECM_TREE_STRUCTURE_CREATION_SHOW_PROGRESS() {
		return Configuration.value('VUE_APP_ECM_TREE_STRUCTURE_CREATION_SHOW_PROGRESS')
	}
	static get VUE_APP_MATOMO_ENABLED() {
		return Configuration.value('VUE_APP_MATOMO_ENABLED')
	}
	static get VUE_APP_MATOMO_URL() {
		return Configuration.value('VUE_APP_MATOMO_URL')
	}
	static get VUE_APP_MATOMO_SITE_ID() {
		return Configuration.value('VUE_APP_MATOMO_SITE_ID')
	}
	static get VUE_APP_MATOMO_TRACKER_FILENAME() {
		return Configuration.value('VUE_APP_MATOMO_TRACKER_FILENAME')
	}
	static get VUE_APP_MATOMO_TRACKER_URL() {
		return Configuration.value('VUE_APP_MATOMO_TRACKER_URL')
	}
	static get VUE_APP_MATOMO_TRACKER_SCRIPT_URL() {
		return Configuration.value('VUE_APP_MATOMO_TRACKER_SCRIPT_URL')
	}
	static get VUE_APP_MATOMO_ENABLE_LINK_TRACKING() {
		return Configuration.value('VUE_APP_MATOMO_ENABLE_LINK_TRACKING')
	}
	static get VUE_APP_MATOMO_REQUIRE_CONSENT() {
		return Configuration.value('VUE_APP_MATOMO_REQUIRE_CONSENT')
	}
	static get VUE_APP_MATOMO_TRACK_INITIAL_VIEW() {
		return Configuration.value('VUE_APP_MATOMO_TRACK_INITIAL_VIEW')
	}
	static get VUE_APP_MATOMO_COOKIES_DISABLE() {
		return Configuration.value('VUE_APP_MATOMO_COOKIES_DISABLE')
	}
	static get VUE_APP_MATOMO_HEARTBEAT_TIMER_ENABLE() {
		return Configuration.value('VUE_APP_MATOMO_HEARTBEAT_TIMER_ENABLE')
	}
	static get VUE_APP_MATOMO_HEARTBEAT_TIMER_INTERVAL() {
		return Configuration.value('VUE_APP_MATOMO_HEARTBEAT_TIMER_INTERVAL')
	}
	static get VUE_APP_MATOMO_DEBUG() {
		return Configuration.value('VUE_APP_MATOMO_DEBUG')
	}
	static get VUE_APP_BASE_DOMAIN() {
		return Configuration.value('VUE_APP_BASE_DOMAIN')
	}
	static get VUE_APP_MOBILEAPP_GITLAB_PROJECT() {
		return Configuration.value('VUE_APP_MOBILEAPP_GITLAB_PROJECT')
	}
	static get VUE_APP_KEYCLOAK_URL() {
		return Configuration.value('VUE_APP_KEYCLOAK_URL')
	}

	static get VUE_APP_KEYCLOAK_REALM() {
		return Configuration.value('VUE_APP_KEYCLOAK_REALM')
	}

	static get VUE_APP_KEYCLOAK_CLIENT_ID() {
		return Configuration.value('VUE_APP_KEYCLOAK_CLIENT_ID')
	}
}

export const Config = Configuration
